import { render } from "./LayInfo.vue?vue&type=template&id=150ba039&scoped=true"
import script from "./LayInfo.vue?vue&type=script&lang=js"
export * from "./LayInfo.vue?vue&type=script&lang=js"

import "./LayInfo.vue?vue&type=style&index=0&id=150ba039&lang=less&scoped=true"

import exportComponent from "/aqua/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-150ba039"]])

export default __exports__